import React, { useState, useEffect } from 'react';
import Tools from '../../Tools';
import Popover from '../../ui/Popover';


const DocsNuestrosParques = (props) => {

    const [selectedAllDocs, setSelectedAllDocs] = useState(true);
    const [loading, setLoading] = useState({ client: false, campaign: false, tasks: false, documents: false, patent: false });
    const [error, setError] = useState(false);
    const [documentId, setDocumentId] = useState(null);

    const toggleAllDebts = () => {
        setSelectedAllDocs(!selectedAllDocs); //variable to toggle
        if (selectedAllDocs) {
            props.documents.forEach(d => { d.selected = false; });
            props.setDebtFn(0);
        } else {
            props.documents.forEach(d => { d.selected = true; });
            props.setDebtFn(props.documents.reduce((a, doc) => { return a + Number(doc.total_a_pagar)}, 0));
        }
    }

    const selectDebt = (event, doc) => {
        if (!event.target.checked) {
            doc.selected = false;
            props.setDebtFn(props.debt - Number(event.target.value));
        } else {
            doc.selected = true;
            props.setDebtFn(props.debt + Number(event.target.value));
        }
    }

    useEffect(() => {
        const totalDebt = props.documents.reduce((a, doc) => { return a + Number(doc.total_a_pagar); }, 0);
        props.setDebtFn(totalDebt);
    }, [props.documents]);

    return (
        <table className="fullWidth">
            <thead>
                <tr>
                    <th><input type="checkbox" onChange={toggleAllDebts} defaultChecked={true} /> &nbsp; Cedente</th>
                    <th className='center'>Documento</th>
                    <th className='center'>Base</th>
                    <th className='center'>Serie</th>
                    <th className='center'>Cuotas Mora</th>
                    <th className='right'>Total a pagar</th>
                    <th className='right'>Vencimiento</th>
                    <th className='right'>Días Mora</th>
                    <th className='right'>% Descuento</th>
                </tr>
            </thead>
            <tbody>
                {props.documents.map((doc, index) => {
                    return (
                        <tr key={index}>
                            <td>
                                <label className="forCheckbox">
                                    <input type="checkbox" name={'ckeck' + index} value={doc.total_a_pagar} onChange={(e) => selectDebt(e, doc)} checked={doc.selected} defaultChecked={true} />
                                    NUESTROS PARQUES 
                                </label>
                            </td>
                            <td className="center">{doc.num_documento}</td>
                            <td className="center">{doc.base}</td>
                            <td className="center">{doc.serie}</td>
                            <td className="center">{doc.cuotas_mora}</td>
                            <td className="right">{Tools.fmtClAmmount(doc.total_a_pagar)}</td>
                            <td className="right">{doc.fecha_vencimiento}</td>
                            <td className="right">{Tools.fmtClNumber(doc.dias_mora)}</td>
                            <td className="right">{doc.cuotas_mora > 0 && doc.cuotas_mora < 4?'10%':'40%'}</td>
                        </tr>
                    );
                })}
            </tbody>
        </table>
    );

}

export default DocsNuestrosParques;